export default __webpack_public_path__ + "images/28e96851125cabb29ed8715ace1996c1.png";